const INTUGINE_SIGNIFY_PAYLOAD_POSTING = 'INTUGINE_SIGNIFY_PAYLOAD_POSTING';
module.exports = { INTUGINE_SIGNIFY_PAYLOAD_POSTING };
